export const AdobeTrackingActions = {
  DOWNLOAD_BASE_SOFTWARE: 'Download:Basis-Software:DownloadStart',
  DOWNLOAD_ADDITIONAL_SOFTWARE: 'Download:Zusatz-Software:DownloadStart',
  DOWNLOAD_MAIN_RELEASE: 'Download:Haupt-Release:DownloadStart',
  DOWNLOAD_SERVICE_RELEASE: 'Download:Service-Release:DownloadStart',
} as const;

export type AdobeTrackingActions =
  (typeof AdobeTrackingActions)[keyof typeof AdobeTrackingActions];
